module.exports = __webpack_public_path__ + "img/google-play-badge.38b243ed.png";